import type { MapMarkerIcon } from '~/components/map';
import type { Transport } from '~/types/JourneyItem.types';

export const transportModeKeys: Record<string, { labelKey: string }> = {
  RAIL: { labelKey: 'journey.mode_rail' },
  TRAM: { labelKey: 'journey.mode_tram' },
  TRAIN: { labelKey: 'journey.mode_train' },
  WALK: { labelKey: 'journey.mode_walk' },
  BUS: { labelKey: 'journey.mode_bus' },
  COACH: { labelKey: 'journey.mode_coach' },
  FERRY: { labelKey: 'journey.mode_ferry' },
  TAXI: { labelKey: 'journey.mode_taxi' },
  SLEEPER: { labelKey: 'journey.mode_sleeper' },
  OVERNIGHT_BUS: { labelKey: 'journey.mode_overnight_bus' },
  OVERNIGHT_FERRY: { labelKey: 'journey.mode_overnight_ferry' },
  JOURNEY: { labelKey: 'journey.mode_journey' }
};

const ticketsIncludedLabelKeys: Partial<Record<Transport, string>> = {
  RAIL: 'overview_tickets_included_train',
  TRAIN: 'overview_tickets_included_train',
  TRAM: 'overview_tickets_included_train',
  JOURNEY: 'overview_tickets_included_train',
  SLEEPER: 'overview_tickets_included_sleeper',
  BUS: 'overview_tickets_included_bus',
  COACH: 'overview_tickets_included_bus',
  OVERNIGHT_BUS: 'overview_tickets_included_bus',
  FERRY: 'overview_tickets_included_ferry',
  OVERNIGHT_FERRY: 'overview_tickets_included_ferry'
};

export function getTicketsIncludedKey(modes: Transport[], isMergedLegGroup: boolean): string {
  return !isMergedLegGroup && modes.length === 1
    ? (ticketsIncludedLabelKeys[modes[0]] ?? 'overview_tickets_included')
    : 'overview_tickets_included';
}

const transportModeMapIcons: Partial<Record<Transport, MapMarkerIcon>> = {
  RAIL: 'train',
  TRAIN: 'train',
  TRAM: 'train',
  JOURNEY: 'train',
  SLEEPER: 'sleeper-train',
  BUS: 'bus',
  COACH: 'bus',
  OVERNIGHT_BUS: 'overnight-bus',
  FERRY: 'ferry',
  OVERNIGHT_FERRY: 'overnight-ferry',
  TAXI: 'taxi',
  WALK: 'walk'
};

export function getTransportMapIcon(mode: Transport | null): MapMarkerIcon {
  return (mode && transportModeMapIcons[mode]) || 'train';
}
